// extracted by mini-css-extract-plugin
module.exports = {"line":"PlayerDetails_line__Rfd6c","label":"PlayerDetails_label__5mfvq","value":"PlayerDetails_value__3fyZN"};